import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
let date = new Date();
let year = moment(date).format("YYYY");
let month = moment(date)
    .format("MMM")
    .toLowerCase();
const createSelectors = parentReducer => {
    return new (class {
        selectUsers = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildVersionWidget_reducer"];
            return reducer.users;
        };
        selectjobPacks = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildVersionWidget_reducer"];
            return reducer.jobPacks;
        };
        selectVehicles = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildVersionWidget_reducer"];
            return reducer.qr;
        };
        selectBuild = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildVersionWidget_reducer"];
            return reducer.build_data;
        };
        selectEnvBuild = store => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["BuildVersionWidget_reducer"];
            return reducer.env_build;
        };
        selectBuildStatus = createSelector(
            [this.selectBuild, this.selectEnvBuild],
            (dbBuild = false, envBuild = false) => {
                if (dbBuild && envBuild) {
                    return compareVersion(
                        envBuild,
                        dbBuild.dashboard_client_build
                    ) === 0
                        ? "good"
                        : "bad";
                } else return "bad";
            }
        );
        selectDashDetails = createSelector(
            [this.selectUsers, this.selectVehicles, this.selectjobPacks],
            (users = false, qr = false, jobPacks = false) => {
                if (users) {
                    let totalEmployees = _.compact(
                        Object.keys(users).map(e => {
                            let validEmployee =
                                _.get(users[e], "profile.deleted") || false;
                            if (!validEmployee) {
                                return users[e];
                            } else return null;
                        })
                    );
                    let totalQrs = qr ? Object.keys(qr).length : 0;

                    let totalJobPacks = 0;
                    if (jobPacks)
                        Object.keys(jobPacks).map(y => {
                            Object.keys(jobPacks[y]).map(m => {
                                totalJobPacks += Object.keys(jobPacks[y][m])
                                    .length;
                                return null;
                            });
                            return null;
                        });

                    let userReportsNode = _.compact(
                        Object.keys(users).map(e => {
                            let node1 = _.get(users[e], "receipts") || false;
                            let year1 = _.get(node1, year) || false;
                            let node = _.get(year1, month) || false;
                            if (node) {
                                return node;
                            } else return null;
                        })
                    );
                    let totalReports = 0;
                    userReportsNode.map(e => {
                        Object.keys(e).map(reports => {
                            if (reports !== "holiday_request") {
                                totalReports += Object.keys(e[reports]).length;
                                return true;
                            } else return false;
                        });
                        return true;
                    });
                    return {
                        totalJobPacks,
                        totalReports,
                        totalQrs,
                        totalEmployees: Object.keys(totalEmployees).length
                    };
                } else return false;
            }
        );
    })();
};
function compareVersion(v1, v2) {
    if (typeof v1 !== "string") return false;
    if (typeof v2 !== "string") return false;

    v1 = v1.split(".");
    v2 = v2.split(".");
    const k = Math.min(v1.length, v2.length);
    for (let i = 0; i < k; ++i) {
        v1[i] = parseInt(v1[i], 10);
        v2[i] = parseInt(v2[i], 10);
        if (v1[i] > v2[i]) return 1;
        if (v1[i] < v2[i]) return -1;
    }
    return v1.length === v2.length ? 0 : v1.length < v2.length ? -1 : 1;
}
export default createSelectors;
